import { render, staticRenderFns } from "./MailFormDiscount.vue?vue&type=template&id=7a8df832"
import script from "./MailFormDiscount.vue?vue&type=script&lang=js"
export * from "./MailFormDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports